import { createContext } from "react";
import { Analytics } from "@segment/analytics-next";

const SegmentContext = createContext<Analytics>(undefined);

export default SegmentContext;
